import React from 'react';

interface AlyzeVideoProps {
  src: string;
  width?: number;
  height?: number;
  className?: string;
  autoPlay?: boolean;
  loop?: boolean;
  muted?: boolean;
  controls?: boolean;
  playsInline?: boolean;
  poster?: string;
  preload?: 'none' | 'metadata' | 'auto';
  style?: React.CSSProperties;
}

export const AlyzeVideo: React.FC<AlyzeVideoProps> = ({
  src,
  width,
  height,
  className,
  autoPlay = false,
  loop = false,
  muted = false,
  controls = true,
  playsInline = false,
  poster,
  preload = 'metadata',
  style
}) => {
  const baseUrl = import.meta.env.VITE_MEDIA_CDN_URL || 'https://d28ffuj7bighkv.cloudfront.net';
  const fullSrc = src.startsWith('http') ? src : `${baseUrl}/${src}`;
  const fullPoster = poster && !poster.startsWith('http') ? `${baseUrl}/${poster}` : poster;
  
  return (
    <video 
      src={fullSrc}
      width={width}
      height={height}
      className={className}
      autoPlay={autoPlay}
      loop={loop}
      muted={muted}
      controls={controls}
      playsInline={playsInline}
      poster={fullPoster}
      preload={preload}
      style={style}
    />
  );
};
